import { createInjectionKey as o } from "../../_utils/vue/create-injection-key.js";
const n = o("n-button-group");
export {
  n as buttonGroupInjectionKey
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/naive-ui@2.42.0_vue@3.5.18/~/naive-ui/es/button-group/src/context.js
// module id = 1636
// module chunks = 67